import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../auth.service';
import { validateForm } from '@shared/helpers/form.helpers';
import { MessageModule } from 'primeng/message';
import { CommonModule } from '@angular/common';
import { getBackendAuthErrorMessage, getFirebaseAuthErrorMessage } from '../../helpers/auth.helpers';
import { LayoutModule } from '@shared/directives/layout/layout.module';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-register',
    standalone: true,
    templateUrl: './register.component.html',
    styleUrl: './register.component.scss',
    imports: [
        CommonModule, 
        RouterModule, 
        MessageModule, 
        LayoutModule, 
        ReactiveFormsModule, 
        FloatLabelModule, 
        InputTextModule,
        ButtonModule,
        TranslateModule
    ]
})
export class RegisterComponent {

    getBackendAuthErrorMessage = getBackendAuthErrorMessage;
    getFirebaseAuthErrorMessage = getFirebaseAuthErrorMessage;

    form: FormGroup = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [Validators.required]),
    })

    constructor(
        public auth: AuthService
    ) { }

    register() {
        if (this.form.valid) {
            this.auth.createUser(this.form.value);
        } else {
            validateForm(this.form)
        }
    }

}
